import '@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import MeasureIcom from '@/assets/icons/MeasureIcon'
import ScaleBathroom from '@/assets/icons/ScaleBathroom'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#ED1F24',
        secondary: '#057FB1',
        accent: '#E6E6E6'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
    iconfont: 'fa',
    values: {
      measure: {
        component: MeasureIcom,
      },
      scale: {
        component: ScaleBathroom,
      }
    },
  }
})
